import React from "react"
import './modal.scss'

export default class Modal extends React.Component {

    render() {

        const { show, onClose, type, title, message } = this.props

        return (
            <div className={(show ? "show " : "") + "modal-mask"}>
                <div className={(show ? "show " : "") + type + " modal fade"} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{title}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {message}
                            </div>
                            <div className="modal-footer">
                                <button onClick={onClose} type="button" className="btn btn-secondary" data-dismiss="modal">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}